const locale = {
  SIGN_UP_TITLE: 'Sign Up',
  SIGN_UP_SUBTITLE: 'Create your account',
  SIGN_UP_BUTTON: 'Sign Up',
  SIGNING_UP: 'Signing up...',
  HAVE_ACCOUNT: 'Already have an account?',
  SIGN_IN_LINK: 'Sign in here',
  
  // Step labels
  STEP_PERSONAL_INFO: 'Personal Info',
  STEP_HOTEL_INFO: 'Hotel Info',
  
  // Navigation
  BACK: 'Back',
  NEXT: 'Next',
  
  // Personal Info fields
  FIRST_NAME_LABEL: 'First Name',
  LAST_NAME_LABEL: 'Last Name',
  USERNAME_LABEL: 'Username',
  
  // Hotel Info fields
  HOTEL_NAME_LABEL: 'Hotel Name',
  HOTEL_DOMAIN_LABEL: 'Hotel Domain',
  
  // Account Info fields
  EMAIL_LABEL: 'Email Address',
  PASSWORD_LABEL: 'Password',
  CONFIRM_PASSWORD_LABEL: 'Confirm Password',
  
  // Validation messages
  FIRST_NAME_REQUIRED: 'First name is required',
  FIRST_NAME_MIN_LENGTH: 'First name must be at least 2 characters',
  LAST_NAME_REQUIRED: 'Last name is required',
  LAST_NAME_MIN_LENGTH: 'Last name must be at least 2 characters',
  USERNAME_REQUIRED: 'Username is required',
  USERNAME_MIN_LENGTH: 'Username must be at least 3 characters',
  USERNAME_INVALID: 'Username can only contain letters, numbers, and underscores',
  HOTEL_NAME_REQUIRED: 'Hotel name is required',
  HOTEL_NAME_MIN_LENGTH: 'Hotel name must be at least 2 characters',
  HOTEL_DOMAIN_REQUIRED: 'Hotel domain is required',
  HOTEL_DOMAIN_INVALID: 'Please enter a valid domain (e.g., example.com)',
  EMAIL_REQUIRED: 'Email address is required',
  EMAIL_INVALID: 'Please enter a valid email address',
  PASSWORD_REQUIRED: 'Password is required',
  PASSWORD_MIN_LENGTH: 'Password must be at least 8 characters',
  CONFIRM_PASSWORD_REQUIRED: 'Please confirm your password',
  PASSWORDS_DONT_MATCH: 'Passwords do not match',
  
  // Password strength
  PASSWORD_STRENGTH_LABEL: 'Password Strength:',
  PASSWORD_STRENGTH_WEAK: 'Weak',
  PASSWORD_STRENGTH_FAIR: 'Fair', 
  PASSWORD_STRENGTH_GOOD: 'Good',
  PASSWORD_STRENGTH_STRONG: 'Strong',
  
  // Password requirements
  PASSWORD_REQUIREMENTS_TITLE: 'Password Requirements:',
  PASSWORD_REQUIREMENT_LENGTH: 'At least 8 characters',
  PASSWORD_REQUIREMENT_UPPERCASE: 'At least 1 uppercase letter',
  PASSWORD_REQUIREMENT_LOWERCASE: 'At least 1 lowercase letter',
  PASSWORD_REQUIREMENT_NUMBER: 'At least 1 number',
  PASSWORD_REQUIREMENT_SPECIAL: 'At least 1 special character',
  PASSWORD_REQUIREMENT_LATIN: 'Only Latin characters allowed',
  PASSWORD_REQUIREMENT_SECURE: 'Passes security analysis',
  PASSWORD_REQUIREMENT_NOT_COMMON: 'Not a commonly used password',
  PASSWORD_IS_SECURE: 'Password meets security standards',
  PASSWORD_NEEDS_IMPROVEMENT: 'Password needs improvement',
  PASSWORD_BASIC_REQUIREMENTS: 'Must contain: uppercase, lowercase, number, special character, 8+ characters, Latin letters only',
  PASSWORD_ANALYZING: 'Analyzing password security...',
  
  // Password tips
  PASSWORD_TIPS_TITLE: 'Tips for a strong password:',
  PASSWORD_TIPS_HELP: 'Need help?',
  PASSWORD_TIP_GENERATE: '• Use the generate button for a secure password',
  PASSWORD_TIP_AVOID_COMMON: '• Avoid common words and predictable patterns',
  PASSWORD_TIP_MIX_CHARS: '• Mix uppercase, lowercase, numbers, and symbols',
  PASSWORD_TIP_UNIQUE: '• Make it unique - don’t reuse passwords',
  
  // Error messages
  INVALID_SIGNUP_DATA: 'Invalid signup data provided',
  EMAIL_ALREADY_EXISTS: 'An account with this email already exists',
  USERNAME_ALREADY_EXISTS: 'This username is already taken',
  HOTEL_NAME_ALREADY_EXISTS: 'A hotel with this name already exists',
  HOTEL_DOMAIN_ALREADY_EXISTS: 'This domain is already in use by another hotel',
  PASSWORD_TOO_WEAK: 'Password is too weak. Use a stronger password',
  PASSWORD_TOO_COMMON: 'Password is too commonly used. Please choose something more secure.',
  GENERATE_PASSWORD: 'Generate secure password',
  PASSWORD_GENERATED: 'Password generated successfully',
  
  // Enzoic feedback messages (these will be mapped from Enzoic feedback)
  ENZOIC_FEEDBACK_TITLE: 'Password Security Analysis:',
  ENZOIC_WEAKNESS_DICTIONARY: 'This password appears in common password lists',
  ENZOIC_WEAKNESS_PREDICTABLE: 'This password follows predictable patterns',
  ENZOIC_WEAKNESS_REPETITIVE: 'This password contains repetitive characters',
  ENZOIC_WEAKNESS_SEQUENCE: 'This password contains sequential characters',
  ENZOIC_WEAKNESS_KEYBOARD: 'This password follows keyboard patterns',
  ENZOIC_WEAKNESS_DATE: 'This password contains date patterns',
  ENZOIC_WEAKNESS_PERSONAL: 'This password may contain personal information',
  ENZOIC_WEAKNESS_COMPROMISED: 'This password has been found in data breaches',
  ACCOUNT_DISABLED: 'Your account has been disabled. Contact support',
  ACCOUNT_LOCKED: 'Account is locked. Contact administrator',
  PASSWORD_SIGNUP_DISABLED: 'Password signup is currently disabled. Please use alternative signup methods',
  ORG_CREATION_FAILED: 'Failed to create hotel organization. Please try again',
  
  // Network and API errors
  NETWORK_ERROR: 'Network error. Please check your connection',
  CONNECTION_TIMEOUT: 'Connection timeout. Please check your internet connection',
  SERVER_ERROR: 'Server error. Please try again later',
  SERVICE_UNAVAILABLE: 'Authentication service is temporarily unavailable',
  BAD_REQUEST: 'Invalid request. Please check your input',
  UNKNOWN_ERROR: 'An error occurred. Please try again',
};

export default locale; 